import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { FormProvider, useForm } from "react-hook-form";
import { PaziaFormButton, PaziaInput, PaziaLoader } from "components/atoms";
import { useArchivedCoursePageSettings, shopApi, ArchivedCoursePageSettings } from "api/shop";
import { useToaster } from "utils";
import { useState, useEffect } from "react";

const FORM_NAMES = {
  OFFER_PAGE_URL: "offerPageUrl",
} as const;

const schema = yup
  .object({
    [FORM_NAMES.OFFER_PAGE_URL]: yup.string().default(""),
  })
  .required();

interface FormValues {
  offerPageUrl: string;
}

export const ShopArchivedCoursePageSettingsForm = () => {
  const { archivedCoursePageSettings, isLoading, invalidate } = useArchivedCoursePageSettings();
  const { showSuccess, showError } = useToaster();
  const [isSaving, setIsSaving] = useState(false);

  const methods = useForm<FormValues>({
    resolver: yupResolver(schema) as any,
    defaultValues: {
      [FORM_NAMES.OFFER_PAGE_URL]: archivedCoursePageSettings?.offerPageUrl ?? "",
    },
  });
  const { handleSubmit, reset } = methods;

  useEffect(() => {
    if (archivedCoursePageSettings !== undefined) {
      reset({
        [FORM_NAMES.OFFER_PAGE_URL]: archivedCoursePageSettings?.offerPageUrl ?? "",
      });
    }
  }, [archivedCoursePageSettings, reset]);

  const onSubmit = async (data: FormValues) => {
    setIsSaving(true);
    try {
      const payload: ArchivedCoursePageSettings = {
        offerPageUrl: data.offerPageUrl || undefined,
      };
      await shopApi.updateArchivedCoursePageSettings(payload);
      showSuccess("Zapisano ustawienia strony archiwalnej");
      invalidate();
    } catch (error) {
      showError("Nie udało się zapisać ustawień");
      console.error(error);
    } finally {
      setIsSaving(false);
    }
  };

  if (isLoading) return <PaziaLoader position="center" />;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)} className="grid max-w-xl gap-6">
        <div className="rounded-lg border border-slate-200 bg-white p-4 dark:border-slate-700 dark:bg-slate-800">
          <h3 className="mb-4 text-lg font-medium text-slate-800 dark:text-slate-200">
            Strona zarchiwizowanego kursu
          </h3>
          <p className="mb-4 text-sm text-slate-500 dark:text-slate-400">
            Gdy użytkownik trafi na stronę kursu, który został usunięty lub zarchiwizowany, zobaczy dedykowany komunikat z przyciskiem prowadzącym do oferty.
          </p>
          <PaziaInput
            name={FORM_NAMES.OFFER_PAGE_URL}
            label="Adres strony z ofertą (URL przycisku)"
            placeholder="https://..."
          />
        </div>
        <div className="flex justify-start">
          <PaziaFormButton disabled={isSaving} />
        </div>
      </form>
    </FormProvider>
  );
};
